export enum WorkspaceRole {
  owner = 'Workspace Owner',
  planner = 'Workspace Content Planner',
  dataManager = 'Workspace Data Manager',
  efsManager = 'Workspace EFS Manager',
  conferencePlanner = 'Workspace Conference Planner',
  questionManager = 'Workspace Question Manager',
  backtagger = 'Workspace Backtagger'
}
